var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center white"},[_c('BaseTypography',{attrs:{"variant":"body-1"}},[_vm._v("Wybierz opcję z menu")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }